import { forwardRef, InputHTMLAttributes, useImperativeHandle, useRef } from 'react';
import priceInputStyles from './PriceInputBase.module.scss';
import classes from 'classnames/bind';
import { useRestrictInputToPrice } from 'src/hooks/useRestrictInputToPrice/useRestrictInputToPrice';

const cx = classes.bind(priceInputStyles);

interface PriceInputBaseProps extends InputHTMLAttributes<HTMLInputElement> {
  dirty?: boolean;
  error?: boolean;
}

const PriceInputBase = forwardRef<HTMLInputElement, PriceInputBaseProps>((props, forwardedRef) => {
  const ref = useRef<HTMLInputElement>(null);
  const { dirty, error, ...rest } = props;

  useImperativeHandle(forwardedRef, () => ref.current);
  useRestrictInputToPrice(ref.current, rest.onChange);

  return (
    <input
      {...rest}
      ref={ref}
      className={cx(
        'input',
        {
          'input-error': error,
          'input-edited': dirty,
        },
        props.className,
      )}
    />
  );
});

PriceInputBase.displayName = 'PriceInputBase';

export default PriceInputBase;
